export default __webpack_public_path__ + "static/media/nfo_postlogin_arbitage_banner_desk.e77c05c4.jpg";